<template>
    <app-form @submit="handle">
        <app-field-text
            class="auth-input"
            :required="true"
            name="email"
            placeholder="Email Address"
            v-model="fields.email"
            :error="errors.email"
        />

        <app-field-password
            class="auth-input"
            :required="true"
            name="password"
            placeholder="Password"
            v-model="fields.password"
            :error="errors.password"
        />

        <app-button element="button" class="btn  btn--primary  btn--primary--full rounded-lg">Sign in</app-button>
    </app-form>
</template>

<script>
    /* API */
    import Api from '@/api/index.js';
    import Auth from '@/api/auth.js';

    import Heading from '@/components/Heading';
    import Form from '@/components/Form';
    import FieldText from '@/components/fields/inputs/Text';
    import FieldPassword from '@/components/fields/inputs/Password';
    import Button from '@/components/Button';

    /* Mixins */
    import ValidationErrors from '@/mixins/validationErrors.js';
    
    /* Constants */
    import {
        AUTH_DASHBOARD_URL
    } from '@/constants/auth.js';
    export default {
        name: 'app-auth-login',

        components: {
            'app-heading': Heading,
            'app-form': Form,
            'app-field-text': FieldText,
            'app-field-password': FieldPassword,
            'app-button': Button
        },

        mixins: [ ValidationErrors ],
        
        data: () => ({
            loading: false,
            fields: {
                email: '',
                password: ''
            },
            errors: {}
        }),
        methods: {
            handle() {
                this.loading = true;
                this.clearErrors();
                Auth.login({
                    email: this.fields.email,
                    password: this.fields.password
                }).then(response => {
                    this.$router.push(AUTH_DASHBOARD_URL);
                }).catch(error => {
                    if(this.hasErrors(error)) {
                        this.addErrors(error);
                    }
                    setTimeout(() => {
                        if(typeof error.response.data.message != 'undefined' && error.response.data.message != '') {
                            this.$toasted.show(error.response.data.message, {
                                type: "error",
                                position: "top-center",
                                duration : 5000
                            });
                        }
                        this.loading = false;
                    }, 500);
                });
            },
        },
        watch: {
            loading(value) {
                this.$emit('loading', value);
            }
        }
    }
</script>

<style lang="scss">
    .auth-input .input {
        @apply .h-12 .rounded-lg;
    }

    .auth-input .field__inner {
        @apply .mb-8;
    }
</style>


// WEBPACK FOOTER //
// src/components/auth/Login.vue